import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children }) => (
  <p className="text-xs font-mono uppercase tracking-[0.28em] text-gold/80 mb-5">
    {children}
  </p>
);

export const SectionHeading = ({ overline, title, text, testid }) => (
  <div className="max-w-3xl">
    <Reveal>
      <Overline>{overline}</Overline>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 data-testid={testid} className="text-2xl sm:text-3xl lg:text-4xl tracking-tight font-serif font-medium leading-snug text-slate-100">
        {title}
      </h2>
    </Reveal>
    {text && (
      <Reveal delay={0.16}>
        <p className="mt-6 text-base sm:text-lg text-slate-400 font-light leading-relaxed">{text}</p>
      </Reveal>
    )}
  </div>
);
